import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ProductWrapper } from '../../Models/Domains/Account/ProductWrapper';

declare var IS_RUNNING_IN_APP_POOL;

export class AvailableProductWrappersClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number, servicePropositionId: number, isQuote: boolean): Promise<Array<ProductWrapper>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/ProductWrappers/AvailableProductWrappers/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, servicePropositionId: servicePropositionId, isQuote: isQuote }

    return AjaxWrapper.get<Array<ProductWrapper>, any>(url, data);
  }
}

